"use client";

import { c as _c } from "react/compiler-runtime";
import { Icon } from "@/components/formatters/MXPIcon";
import { renderContentfulImage } from "@/components/terra/utils/renderImage";
import { FocalPointImageProps } from "../../component/FocusedImage/FocusedImageMethods";
import { RegularImageProps } from "../../utils/types/RegularImageProps";
import { TerraLink } from "../../component/TerraLink/TerraLink";
export interface FeatureItem {
  header: string;
  ctaLink: {
    url: string;
    destination: string;
  };
  image: FocalPointImageProps | RegularImageProps | null;
  description: string;
}
export interface FeatureCarouselItemProps {
  index: number;
  item: FeatureItem;
  isActive?: boolean;
  activeIndex?: number;
  featureItems?: FeatureItem[];
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  componentImagePriority?: "high" | "auto" | "low";
  isLCP?: boolean;
  isDesktop?: boolean;
}
const FeatureCarouselItem = t0 => {
  const $ = _c(72);
  const {
    index,
    item,
    isActive,
    activeIndex: t1,
    onMouseEnter,
    onMouseLeave,
    componentImagePriority,
    isLCP: t2,
    isDesktop: t3
  } = t0;
  const activeIndex = t1 === undefined ? 0 : t1;
  const isLCP = t2 === undefined ? false : t2;
  const isDesktop = t3 === undefined ? false : t3;
  const imageSrc = (item?.image as RegularImageProps)?.src || "";
  const imageAlt = (item?.image as RegularImageProps)?.alt || "";
  const hasLink = !!(item?.ctaLink?.url || item?.ctaLink?.destination);
  const shouldShift = isDesktop && index > activeIndex;
  if (isDesktop) {
    let t4;
    if ($[0] !== shouldShift) {
      t4 = shouldShift ? {
        transform: "translate3d(117px, 0, 0)"
      } : undefined;
      $[0] = shouldShift;
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    const t5 = item?.ctaLink?.url || item?.ctaLink?.destination;
    const t6 = `${item?.header}${isActive ? " (active)" : ""}`;
    const t7 = `no-underline [transform-origin:bottom_left] ${hasLink ? "cursor-pointer" : "cursor-default"}`;
    const t8 = isActive ? "scale-150 shadow-[0_10px_20px_rgba(0,0,0,0.5)] opacity-100 border-b-[10px] border-b-yellow-m10" : "opacity-70";
    const t9 = !isActive ? "focus:outline-2 focus:outline-black focus-within:outline-2 focus-within:outline-black" : "";
    let t10;
    if ($[2] !== t7 || $[3] !== t8 || $[4] !== t9) {
      t10 = ["relative inline-block transition-all duration-[450ms] ease-in-out", "w-[234px] h-[262px] rounded text-gray-m9 text-xl font-bold leading-[1.625rem]", t7, "[&>*]:pointer-events-none", "motion-reduce:transition-none", "focus:no-underline active:no-underline hover:no-underline", t8, t9];
      $[2] = t7;
      $[3] = t8;
      $[4] = t9;
      $[5] = t10;
    } else {
      t10 = $[5];
    }
    const t11 = t10.join(" ");
    const t12 = isActive ? "grayscale-0" : "grayscale";
    let t13;
    if ($[6] !== t12) {
      t13 = ["rounded absolute inset-0 w-full h-full object-cover bg-cover bg-center z-0", "transition-[filter] duration-300 motion-reduce:transition-none", t12];
      $[6] = t12;
      $[7] = t13;
    } else {
      t13 = $[7];
    }
    const t14 = t13.join(" ");
    const t15 = (item?.image as any)?.focusArea;
    let t16;
    if ($[8] !== componentImagePriority || $[9] !== imageAlt || $[10] !== imageSrc || $[11] !== isLCP || $[12] !== t14 || $[13] !== t15) {
      t16 = renderContentfulImage(imageSrc, imageAlt, 702, 786, t14, 65, t15, componentImagePriority, isLCP);
      $[8] = componentImagePriority;
      $[9] = imageAlt;
      $[10] = imageSrc;
      $[11] = isLCP;
      $[12] = t14;
      $[13] = t15;
      $[14] = t16;
    } else {
      t16 = $[14];
    }
    const t17 = isActive ? "items-end text-white text-xs" : "items-center";
    let t18;
    if ($[15] !== t17) {
      t18 = ["absolute inset-0 w-full h-full bg-gradient-to-b from-transparent to-gray-m10/90 flex p-4 z-[1]", t17];
      $[15] = t17;
      $[16] = t18;
    } else {
      t18 = $[16];
    }
    const t19 = t18.join(" ");
    const t20 = isActive ? "flex items-center justify-between w-full" : "";
    const t21 = isActive ? "text-sm w-[130px] leading-4 text-white" : "text-yellow-m10";
    let t22;
    if ($[17] !== t21) {
      t22 = ["!mb-0", t21];
      $[17] = t21;
      $[18] = t22;
    } else {
      t22 = $[18];
    }
    const t23 = t22.join(" ");
    const t24 = item?.header;
    let t25;
    if ($[19] !== t23 || $[20] !== t24) {
      t25 = <h3 className={t23}>{t24}</h3>;
      $[19] = t23;
      $[20] = t24;
      $[21] = t25;
    } else {
      t25 = $[21];
    }
    let t26;
    if ($[22] !== hasLink || $[23] !== isActive) {
      t26 = isActive && hasLink && <Icon className="p-3 border border-white rounded-full" type="t2u-chevron-right" size={38} />;
      $[22] = hasLink;
      $[23] = isActive;
      $[24] = t26;
    } else {
      t26 = $[24];
    }
    let t27;
    if ($[25] !== t20 || $[26] !== t25 || $[27] !== t26) {
      t27 = <div className={t20}>{t25}{t26}</div>;
      $[25] = t20;
      $[26] = t25;
      $[27] = t26;
      $[28] = t27;
    } else {
      t27 = $[28];
    }
    let t28;
    if ($[29] !== t19 || $[30] !== t27) {
      t28 = <div className={t19}>{t27}</div>;
      $[29] = t19;
      $[30] = t27;
      $[31] = t28;
    } else {
      t28 = $[31];
    }
    let t29;
    if ($[32] !== index || $[33] !== onMouseEnter || $[34] !== onMouseLeave || $[35] !== t11 || $[36] !== t16 || $[37] !== t28 || $[38] !== t5 || $[39] !== t6) {
      t29 = <TerraLink destination={t5} key={index} linkType="text" disableStyles={true} tabIndex={0} ariaLabel={t6} className={t11} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>{t16}{t28}</TerraLink>;
      $[32] = index;
      $[33] = onMouseEnter;
      $[34] = onMouseLeave;
      $[35] = t11;
      $[36] = t16;
      $[37] = t28;
      $[38] = t5;
      $[39] = t6;
      $[40] = t29;
    } else {
      t29 = $[40];
    }
    let t30;
    if ($[41] !== isActive || $[42] !== item?.description) {
      t30 = isActive && <div className="w-[351px] text-gray-m9 text-md px-2.5 mt-[30px] leading-md h-[120px] overflow-hidden t2-dark:text-white">{item?.description}</div>;
      $[41] = isActive;
      $[42] = item?.description;
      $[43] = t30;
    } else {
      t30 = $[43];
    }
    let t31;
    if ($[44] !== t29 || $[45] !== t30 || $[46] !== t4) {
      t31 = <div className="t2-lo-feature-carousel__item inline-block w-[234px] transition-transform duration-[450ms] ease-in-out motion-reduce:transition-none" style={t4}>{t29}{t30}</div>;
      $[44] = t29;
      $[45] = t30;
      $[46] = t4;
      $[47] = t31;
    } else {
      t31 = $[47];
    }
    return t31;
  }
  const t4 = item?.ctaLink?.url || item?.ctaLink?.destination;
  const t5 = `block no-underline ${hasLink ? "cursor-pointer" : "cursor-default"} focus:no-underline active:no-underline hover:no-underline`;
  const t6 = (item?.image as any)?.focusArea;
  let t7;
  if ($[48] !== componentImagePriority || $[49] !== imageAlt || $[50] !== imageSrc || $[51] !== isLCP || $[52] !== t6) {
    t7 = renderContentfulImage(imageSrc, imageAlt, 480, 400, "rounded absolute inset-0 w-full h-full object-cover bg-cover bg-center z-0 grayscale-0", 65, t6, componentImagePriority, isLCP);
    $[48] = componentImagePriority;
    $[49] = imageAlt;
    $[50] = imageSrc;
    $[51] = isLCP;
    $[52] = t6;
    $[53] = t7;
  } else {
    t7 = $[53];
  }
  const t8 = item?.header;
  let t9;
  if ($[54] !== t8) {
    t9 = <h3 className="text-lg max-w-[135px] text-white !mb-0">{t8}</h3>;
    $[54] = t8;
    $[55] = t9;
  } else {
    t9 = $[55];
  }
  let t10;
  if ($[56] !== hasLink) {
    t10 = hasLink && <Icon className="p-3 border border-white rounded-full flex" type="t2u-chevron-right" size={38} />;
    $[56] = hasLink;
    $[57] = t10;
  } else {
    t10 = $[57];
  }
  let t11;
  if ($[58] !== t10 || $[59] !== t9) {
    t11 = <div className="absolute inset-0 w-full h-full bg-gradient-to-b from-transparent to-gray-m10/90 flex items-end text-white text-xs p-3"><div className="flex items-center justify-between w-full">{t9}{t10}</div></div>;
    $[58] = t10;
    $[59] = t9;
    $[60] = t11;
  } else {
    t11 = $[60];
  }
  let t12;
  if ($[61] !== t11 || $[62] !== t7) {
    t12 = <div className="relative w-full min-h-[282px] sm:min-h-[400px] rounded border-b-[10px] border-b-yellow-m10 overflow-hidden">{t7}{t11}</div>;
    $[61] = t11;
    $[62] = t7;
    $[63] = t12;
  } else {
    t12 = $[63];
  }
  const t13 = item?.description;
  let t14;
  if ($[64] !== t13) {
    t14 = <div className="text-gray-m9 text-base px-2.5 mt-7 leading-5 h-[102px] overflow-hidden t2-dark:text-white">{t13}</div>;
    $[64] = t13;
    $[65] = t14;
  } else {
    t14 = $[65];
  }
  let t15;
  if ($[66] !== index || $[67] !== t12 || $[68] !== t14 || $[69] !== t4 || $[70] !== t5) {
    t15 = <TerraLink destination={t4} key={index} linkType="text" disableStyles={true} tabIndex={0} className={t5}>{t12}{t14}</TerraLink>;
    $[66] = index;
    $[67] = t12;
    $[68] = t14;
    $[69] = t4;
    $[70] = t5;
    $[71] = t15;
  } else {
    t15 = $[71];
  }
  return t15;
};
export default FeatureCarouselItem;